export default {"src":"/_next/static/media/icono3punto.81325963.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};